<template>
  <div
    class="boxGenitor mb-4"
    :class="{'boxGenitor_error': verifyError()}">
    <div class="boxGenitor_header p-2">
      <h3 class="boxGenitor_header_title">
        {{ pessoaPessoa.nome }}
      </h3>
    </div>

    <div class="boxGenitor_body px-3 py-2">
      <div class="row no-gutters align-items-center justify-content-between">
        <div class="d-inline-flex boxGenitor_body_content">
          <div class="d-inline-block mr-5">
            <ul class="boxGenitor_list">
              <li class="boxGenitor_list_item boxGenitor_list_title">
                Profissão
              </li>

              <li class="boxGenitor_list_item">
                <strong>{{ profissao }}</strong>
              </li>
            </ul>
          </div>

          <div v-if="pessoaPessoa.naturalidade">
            <ul class="boxGenitor_list">
              <li class="boxGenitor_list_item boxGenitor_list_title">
                Naturalidade
              </li>

              <li class="boxGenitor_list_item">
                <strong> {{ pessoaPessoa.naturalidade || 'Não cadastrado' }} </strong>
              </li>
            </ul>
          </div>

          <div v-if="pessoaPessoa.nacionalidade"
               class="d-inline-block ml-2">
            <ul class="boxGenitor_list">
              <li class="boxGenitor_list_item boxGenitor_list_title">
                Nacionalidade
              </li>

              <li class="boxGenitor_list_item">
                <strong> {{ pessoaPessoa.nacionalidade.nome || 'Não cadastrado' }} </strong>
              </li>
            </ul>
          </div>

          <div class="d-inline-block ml-5">
            <ul class="boxGenitor_list">
              <li class="boxGenitor_list_item boxGenitor_list_title">
                Endereço Cadastrado
              </li>

              <li class="boxGenitor_list_item">
                <strong>{{ pessoaPessoa.endereco && pessoaPessoa.endereco.exterior == true ? pessoaPessoa.endereco : pessoaPessoa | Endereco(true) }}</strong>
              </li>
            </ul>
          </div>
        </div>

        <div class="">
          <div v-if="!noEditButton"
               class="row no-gutters justify-content-end align-items-center">
            <div class="d-inline-block">
              <slot />
            </div>
          </div>
        </div>
      </div>
    </div>
    <BoxAvos v-if="propNascimento"
             :prop-genitor="pessoa" />
  </div>
</template>

<script>

  import BoxAvos from '@/components/SofiaRei/Obito/BoxAvos.vue'

  export default {
    name: 'BoxGenitores',
    components: { BoxAvos },
    props: {
      pessoa: { type: Object, default: ()=>({}) },
      noEditButton: Boolean,
      propVerifySexoGenitores: {type: Boolean, default: false},
      propCorrecoes: {type: Object, default: () => ({})},
      propNascimento: { type: Boolean, default: false },
      propOrdem: { type: Number, default: 0}
    },
    computed: {
      pessoaPessoa () {
        return this.pessoa.pessoa || this.pessoa
      },
      profissao () {
        return this.pessoaPessoa.ocupacao_declarada || 'Não cadastrado'
      }
    },
    methods: {
      verifyError () {
        if (!this.propVerifySexoGenitores) return

        if (this.pessoa.pessoa.sexo == 'M') {
          return this.propCorrecoes['PAI', `PAI DO CÔNJUGE ${this.propOrdem}`]
        } else {
          return this.propCorrecoes['MÃE', `MÃE DO CÔNJUGE ${this.propOrdem}`]
        }
      },
    }
  }
</script>

<style lang="scss">
  @import '/../../../scss/_utilities/_exports';

  .boxGenitor {
    box-shadow: 0 0 pxToRem(4) 0 $color-dark;

    &_error {
      border: solid 2px #8B0000;
      border-radius: 2px;
    }

    &_header {
      background-color: #01AEC9;
      color: $color-dark;

      &_title {
        font-size: pxToRem(14);
        font-weight: 500;
      }
    }

    &_body {
      &_content {}
    }

    &_list {
      font-size: pxToRem(14);
      list-style: none;
      margin: 0;
      padding: 0;

      &_item {}

      &_title {
        margin-bottom: pxToRem(4);
        text-decoration: underline;
      }
    }
  }

</style>
